// this file added by Bearer Web Developer

import { getEnv, Instance, types, getParentOfType } from "mobx-state-tree";
import { EnvType, OrderState } from "../app-state";

// RiderState added by Bearer Web Developer start
export interface Location {
    lat: number,
    lng: number,
}
export interface Path {
    distanse: number,
    duration: number,
    length: string,
    overview_polyline: Location[],
    time: string,
}
export const RiderState = types
    .model("RiderState", {
        location: types.maybeNull(types.frozen<Location>()),
        path: types.maybeNull(types.frozen<Path>()),
    })
    .views(self => ({
        get riderLocation() {
            return self.location;
        },
        get transportId(): string | undefined {
            return getParentOfType(self, OrderState).transport.value?.transport_id;
        },
        get riderPath() {
            return self.path;
        },

    }))
    .actions(self => {
        return {
            setRiderLocation(value: Location | null) {
                self.location = value;
            },
            setRiderPath(value: Path | null) {
                self.path = value;
            },
            clear() {
                self.location = null;
                self.path = null;
            },
            loadRiderLocation() {
                const transportId = self.transportId;
                if (!transportId) {
                    return;
                }
                const api = getEnv<EnvType>(self).api;

                ///// To solve AppCheck - WebApp Issue on Loading App State and Tabs if any
                api.callApiWithAppCheck();

                const orderState = getParentOfType(self, OrderState);
                api.riderLocation(orderState, transportId);
            },
            loadRiderPath() {
                const transportId = self.transportId;
                if (!transportId) {
                    return;
                }
                const api = getEnv<EnvType>(self).api;

                ///// To solve AppCheck - WebApp Issue on Loading App State and Tabs if any
                api.callApiWithAppCheck();

                const orderState = getParentOfType(self, OrderState);
                api.riderPath(orderState, transportId);
            },
        }
    })
export interface IRiderState extends Instance<typeof RiderState> { };
// RiderState added by Bearer Web Developer end